// test1871
(1871 && 0);
